import { GalleryItem, GalleryCollection } from '@/store/gallery/types'
import { MediaItem, MediaCollection } from '@/serato-media-stock'

export const seratoMediaItemToGalleryItem = (mediaItem: MediaItem): GalleryItem => {
  // if item is an image, it doesnt need video source, but it does if its a video
  let previewVideoSource = null
  if (mediaItem.type === 'video' && mediaItem.preview.video) {
    previewVideoSource = {
      width: mediaItem.preview.video.width,
      height: mediaItem.preview.video.height,
      src: mediaItem.preview.video.src
    }
  }

  return {
    type: mediaItem.type,
    widthToHeightRatio: mediaItem.width / mediaItem.height,
    preview: {
      imageSource: {
        width: mediaItem.preview.image.width,
        height: mediaItem.preview.image.height,
        src: mediaItem.preview.image.src
      },
      videoSource: previewVideoSource
    },
    source: [
      {
        width: mediaItem.width,
        height: mediaItem.height,
        src: mediaItem.src
      }
    ]
  }
}

export const seratoCollectionToGalleryCollection = (collection: MediaCollection): GalleryCollection => {
  return {
    id: collection.id,
    title: collection.title,
    source: 'serato'
  }
}

export const collectionNameSorter = (collectionsOrder: string[]): (a: GalleryCollection, b: GalleryCollection) => number => {
  return (a: GalleryCollection, b: GalleryCollection): number => {
    const aPosition = collectionsOrder.indexOf(a.title) // need to take in as param somehow
    const bPosition = collectionsOrder.indexOf(b.title)
    if (aPosition > -1 && bPosition > -1) {
      return aPosition - bPosition
    }
    return 1
  }
}